var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.schemaData),function(data){return _c('script',{key:data['@type'],attrs:{"type":"application/ld+json"}},[_vm._v(" "+_vm._s(data)+" ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }